import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface ContextMenuBackdropProps extends PartProps<BaseContextMenu.Backdrop.Props> {
  className?: string
}

function ContextMenuBackdrop({ className, ...props }: ContextMenuBackdropProps) {
  return (
    <BaseContextMenu.Backdrop
      className={twMerge(
        'fixed inset-0',
        'bg-backdrop-subtle',
        'transition-opacity',
        'data-[starting-style]:opacity-0',
        'data-[ending-style]:opacity-0',
        className,
      )}
      {...props}
    />
  )
}

export { ContextMenuBackdrop }
